module.exports = __webpack_public_path__ + "media/elegant.ad08ff67.mp3";